<template>
  <div class="pt-3 pb-5">
    <swiper
      :slidesPerView="'auto'"
      :freeMode="true"
      :pagination="{
        type: 'progressbar',
      }"
      class="button-slider"
    >
      <swiper-slide v-for="(button, index) in buttons" :key="index" :class="{'d-none': button.hide}">
        <button
          type="button"
          class="btn border rounded-pill"
          :class="{ active: button.isSelected}"
          @mousedown="preventFocus"
          @click="clickEvent(button)"
        >
          {{ button.name }}
        </button></swiper-slide
      >
    </swiper>
  </div>
</template>
<script>
import "swiper/css";

import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore, { Pagination, Navigation } from "swiper";
SwiperCore.use([Pagination, Navigation]);
export default {
  name: "ButtonSwiper",
  props: ["buttons"],
  components: {
    Swiper,
    SwiperSlide,
  },
  methods: {
    clickEvent: function (item) {
      this.$emit("clickEvent", item);
    },
    preventFocus: function (event) {
      // Prevents focus styling on click
      event.preventDefault();
    }
  },
};
</script>
